$shm_hitalama_quick2 $mol_view
	hovered_id? \
	vertical false
	attr *
		^
		shm_hitalama_quick2_vertical <= vertical
	auto /
		<= keydown_listener $shm_listener /
			\keydown
			<= keydown_handler null
	sub /
		<= Panel $mol_view
			attr *
				^
				shm_hitalama_quick2_vertical <= vertical
			sub <= buttons /
		^ hovered_title_visible /
			<= Hovered_title $mol_view
				sub / <= hovered_title \hovered_title
	Button* $mol_check
		checked? <=> checked*? false
		event *
			^
			pointerenter? <=> pointerenter*? null
			pointerleave? <=> pointerleave*? null
		sub /
			<= Speck* $mol_view
				sub / <= item_hotkey* \
			<= Label* $mol_view
				sub / <= item_label* \
